var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "640px",
    height: "560px",
    viewBox: "0 0 640 560",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0088CE",
    strokeWidth: 10,
    fill: "#FFFFFF",
    cx: 37.5,
    cy: 232.5,
    r: 37.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0088CE",
    strokeWidth: 10,
    fill: "#FFFFFF",
    cx: 215.5,
    cy: 37.5,
    r: 37.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0088CE",
    strokeWidth: 10,
    fill: "#FFFFFF",
    cx: 417.5,
    cy: 477.5,
    r: 37.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0088CE",
    strokeWidth: 10,
    fill: "#FFFFFF",
    cx: 552.5,
    cy: 152.5,
    r: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5,224.5 L520.5,171.5",
    id: "Line",
    stroke: "#0088CE",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5,362.5 L393.5,445.5",
    id: "Line",
    stroke: "#0088CE",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5,416.5 L254.5,355.5",
    id: "Line",
    stroke: "#0088CE",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,239.5 L176.5,269.5",
    id: "Line",
    stroke: "#0088CE",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,72.5 L287.5,158.5",
    id: "Line",
    stroke: "#0088CE",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87493,290.926335 C249.841913,298.910557 249.841913,311.830158 241.87493,319.814381 L235.124955,326.558672 C231.30166,330.409598 226.097592,332.575637 220.668759,332.575637 C215.239927,332.575637 210.035859,330.409598 206.212564,326.558672 L159.975238,280.360279 C152.008254,272.376057 152.008254,259.456456 159.975238,251.472234 L166.725212,244.727943 C174.716163,236.767668 187.646652,236.767668 195.637603,244.727943 L241.87493,290.926335 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.262447,203.250554 C229.271496,195.290279 216.341007,195.290279 208.350056,203.250554 L201.600081,209.994845 C193.633098,217.979067 193.633098,230.898668 201.600081,238.882891 L247.837407,285.081283 C255.828358,293.041558 268.758848,293.041558 276.749799,285.081283 L283.499773,278.336992 C291.466757,270.35277 291.466757,257.433169 283.499773,249.448946 L237.262447,203.250554 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.449484,243.941109 C352.458533,235.980834 339.528044,235.980834 331.537093,243.941109 L324.787118,250.6854 C316.820135,258.669622 316.820135,271.589223 324.787118,279.573446 L371.024444,325.771838 C379.015395,333.732113 391.945885,333.732113 399.936836,325.771838 L406.68681,319.027547 C414.653794,311.043325 414.653794,298.123724 406.68681,290.139501 L360.449484,243.941109 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.074328,202.351315 C394.083377,194.391041 381.152887,194.391041 373.161936,202.351315 L366.411962,209.095606 C358.444978,217.079829 358.444978,229.99943 366.411962,237.983652 L412.536788,284.182044 C416.360084,288.03297 421.564151,290.19901 426.992984,290.19901 C432.421817,290.19901 437.625884,288.03297 441.44918,284.182044 L448.199154,277.437753 C456.166138,269.453531 456.166138,256.53393 448.199154,248.549708 L402.074328,202.351315 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.237116,156.602543 C333.2041,148.61832 333.2041,135.698719 325.237116,127.714497 L318.487142,120.970206 C310.496191,113.009931 297.565702,113.009931 289.57475,120.970206 L243.449924,167.168598 C235.48294,175.152821 235.48294,188.072422 243.449924,196.056644 L250.199898,202.800935 C258.19085,210.76121 271.121339,210.76121 279.11229,202.800935 L325.237116,156.602543 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.86196,198.192336 C374.828943,190.208114 374.828943,177.288513 366.86196,169.30429 L360.111985,162.56 C356.28869,158.709074 351.084622,156.543034 345.65579,156.543034 C340.226957,156.543034 335.022889,158.709074 331.199594,162.56 L284.962268,208.645987 C276.995284,216.630209 276.995284,229.54981 284.962268,237.534033 L291.712242,244.278324 C299.703194,252.238598 312.633683,252.238598 320.624634,244.278324 L366.86196,198.192336 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.349616,318.915142 C333.316599,310.93092 333.316599,298.011319 325.349616,290.027096 L318.599641,283.282806 C314.776346,279.43188 309.572278,277.26584 304.143446,277.26584 C298.714613,277.26584 293.510545,279.43188 289.68725,283.282806 L243.449924,329.481198 C235.48294,337.46542 235.48294,350.385021 243.449924,358.369243 L250.199898,365.113534 C254.023194,368.96446 259.227261,371.1305 264.656094,371.1305 C270.084927,371.1305 275.288994,368.96446 279.11229,365.113534 L325.349616,318.915142 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.97446,360.504936 C374.941443,352.520713 374.941443,339.601112 366.97446,331.61689 L360.224485,324.872599 C352.233534,316.912324 339.303045,316.912324 331.312094,324.872599 L285.074767,371.070991 C277.107784,379.055214 277.107784,391.974815 285.074767,399.959037 L291.824742,406.703328 C295.648037,410.554254 300.852105,412.720294 306.280938,412.720294 C311.70977,412.720294 316.913838,410.554254 320.737133,406.703328 L366.97446,360.504936 Z",
    id: "Path",
    fill: "#0685CA"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0088CE",
    strokeWidth: 10,
    fill: "#FFFFFF",
    cx: 97.5,
    cy: 437.5,
    r: 37.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75111cb317a4a1b0e93d7e798031790f.svg";
export { ForwardRef as ReactComponent };